<template>
  <div class="videoCall">
    <el-dialog
      title
      top="0"
      fullscreen
      :visible.sync="videoCallVisible"
      :before-close="hangUp"
    >
      <div
        ref="remotevideo"
        class="container"
      >
        中间视频区域
        <!--<video></video>-->
      </div>
      <!--<p class="roomName">房间：ddddd (d8lk7l4ed)</p>-->
      <div class="roomUsers">
        <div class="list userHost">
          <!--<div class="left">报修方</div>-->
          <div class="right">
            {{ inviteUser.user_name }}
          </div>
        </div>
        <div class="list userGuest">
          <!--<div class="left">z</div>-->
          <div class="right">
            {{ acceptUser.user_name }}
          </div>
        </div>
      </div>

      <div
        ref="localvideo"
        class="roomPicture"
      />
      <div class="roomOperation">
        <!--<div class="item">-->
        <!--<el-button type="info" circle>-->
        <!--<svg-icon icon-class="copyLink"/>-->
        <!--</el-button>-->
        <!--</div>-->
        <!--<div class="item">-->
        <!--<el-button type="info" circle>-->
        <!--<svg-icon icon-class="video"/>-->
        <!--</el-button>-->
        <!--</div>-->
        <div class="item callup">
          <el-button
            v-if="hangUpBtn"
            type="danger"
            circle
            @click="hangUp()"
          >
            <svg-icon icon-class="call" />
          </el-button>
          <el-button
            v-else
            type="infor"
            circle
          >
            <svg-icon icon-class="call" />
          </el-button>
        </div>
        <div class="item">
          {{ countdown }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isIE, isSafari } from '@/utils/index';
import { getRoomToken, enterRoom, leaveRoom, acceptanceRtc } from '@/api/rtc';
import { UserModule } from '@/store/modules/user';
import { AppModule } from '@/store/modules/app';
// import { mapGetters } from 'vuex';
import { PushJumpType } from '@/const';
export default {
  name: 'VideoCall',
  props: {
    videoCallVisible: {
      type: Boolean,
      default: false
    },
    acceptData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      QNRTC: null,
      roomToken: '',
      encode_str: '',
      myRoom: null,
      localTracks: [],
      users: [],
      isMergeStream: 0,
      msgObj: null,

      inviteUser: { user_id: 0, user_name: '' },
      acceptUser: { user_id: 0, user_name: '' },

      minutes: 0,
      seconds: 0,
      timeOut: null,
      interVal: null,
      hangUpBtn: true
    };
  },
  computed: {
    // ...mapGetters(['userInfo', 'messages']),
    messages() {
      return AppModule.messages;
    },

    lastMessage() {
      return this.messages[this.messages.length - 1];
    },

    countdown() {
      if (this.minutes === 0 && this.seconds === 0) {
        return '00:00';
      }
      let minutes = this.minutes < 10 ? '0' + this.minutes : this.minutes;
      let seconds = this.seconds < 10 ? '0' + this.seconds : this.seconds;

      return minutes + ':' + seconds;
    }
  },

  watch: {
    lastMessage: function(newValue) {
      let custom = newValue.content.msg_body.extras;
      if (
        parseInt(custom.jump_type) === parseInt(PushJumpType.ORDERRTC_BUSY) ||
        parseInt(custom.jump_type) === parseInt(PushJumpType.ORDERRTC_END)
      ) {
        this.leaveRoom();
      }
    }
  },

  created() {
    if (isIE() > 0 || isSafari()) {
      this.$nextTick(function() {
        this.$message({
          message:
            '不支持IE和11.0版本以下的Safari浏览器,请使用chrome浏览器,或其它浏览器',
          type: 'error',
          duration: 10000
        });
      });
    } else {
      import('pili-rtc-web')
        .then(module => {
          this.QNRTC = module;
          this.inviteUser = {
            user_id: UserModule.getUserId,
            user_name: UserModule.getUserName
          };
          this.joinRoom();
        })
        .catch(err => {
          let msg = err.msg;
        });
    }
  },

  mounted() {
    let _this = this;
    this.$nextTick(function() {
      window.addEventListener('beforeunload', e => {
        _this.leaveRoom();
      });
    });
  },

  methods: {
    async joinRoom() {
      let _this = this;
      let query = this.$route.query;
      query.type = 1;
      try {
        // 如果发起 获取roomToken
        let tokenRes;
        // eslint-disable-next-line no-prototype-builtins
        if (_this.acceptData && _this.acceptData.hasOwnProperty('encode_str')) {
          tokenRes = await acceptanceRtc({
            encode_str: _this.acceptData.encode_str
          });
        } else {
          try {
            tokenRes = await getRoomToken(query);
          } catch (err) {
            _this.$message({
              message: err.msg,
              type: 'error',
              duration: 5000
            });
          }
        }
        if (tokenRes.code === 0) {
          _this.roomToken = tokenRes.data.roomToken;
          _this.isMergeStream = tokenRes.data.isMergeStream;
          _this.encode_str = tokenRes.data.encode_str;
        } else {
          _this.$message({
            message: tokenRes.msg,
            type: 'error',
            duration: 5000
          });
          return;
        }

        // 加入房间
        _this.myRoom = new _this.QNRTC.TrackModeSession();
        _this.users = await _this.myRoom.joinRoomWithToken(_this.roomToken);
        // 调取后端加入房间接口
        let enterRes = await enterRoom({ encode_str: this.encode_str });
        if (enterRes.code !== 0) {
          _this.$message({
            message: enterRes.msg,
            type: 'error',
            duration: 5000
          });
          return;
        }
      } catch (err) {
        if (err.code === 10022) {
          _this.$message.error('用户已存在!');
        }
        let msg = err.msg;
        return;
      }

      // 订阅房间中已经存在的 tracks
      if (_this.users.length > 1) {
        _this.subscribeTracks(_this.myRoom.trackInfoList);
      } else {
        // 120秒等待
        _this.msgObj = _this.$message({ message: '视频接通中', duration: 0 });
        _this.timeOut = setTimeout(function() {
          if (_this.acceptUser.user_id === 0) {
            _this.msgObj.close();
            _this.$message({
              message: '视频未接听',
              type: 'error',
              duration: 5000
            });
            _this.leaveRoom();
          }
        }, 60000);
      }

      await _this.publish();

      // 监听房间中其他人发布的 Track，自动订阅它们
      _this.myRoom.on('track-add', tracks => {
        _this.subscribeTracks(tracks, 1);
        _this.msgObj.close();
      });

      // 房间有其他人离开房间
      _this.myRoom.on('user-leave', user => {
        _this.leaveRoom();
        _this.$message({
          message: '对方已挂断',
          type: 'error',
          duration: 5000
        });
      });
    },

    async publish() {
      // 我们打开了 2 个参数，即采集音频，采集视频.
      // 这个函数会返回一个列表，列表中每一项就是一个音视频轨对象
      let _this = this;
      try {
        _this.localTracks = await _this.QNRTC.deviceManager.getLocalTracks({
          audio: { enabled: true, tag: 'audio' },
          video: { enabled: true, tag: 'video' }
        });
      } catch (e) {
        _this.$message({
          message: '采集失败，请检查您的设备!',
          type: 'error',
          duration: 5000
        });
      }

      _this.$nextTick(function() {
        const localVideo = _this.$refs['localvideo'];
        for (const track of _this.localTracks) {
          if (track.info.kind === 'video') {
            track.play(localVideo, true);
            track.setMaster(true);
          }
          if (track.info.kind === 'audio') {
            track.setMaster(true);
          }
        }
      });
      try {
        // 发布采集到的 Tracks
        await _this.myRoom.publish(_this.localTracks);
      } catch (e) {
        _this.$message({
          message: '发布失败，请重试!',
          type: 'error',
          duration: 5000
        });
      }
    },
    async subscribeTracks(trackInfoList, isJoin = 0) {
      // 批量订阅 tracks，并在页面上播放
      let _this = this;
      _this.$nextTick(function() {
        const remoteVideo = _this.$refs['remotevideo'];
        _this.myRoom
          .subscribe(trackInfoList.map(t => t.trackId))
          .then(tracks => {
            for (const track of tracks) {
              track.play(remoteVideo);
            }

            // 开启时间计时
            _this.interVal = setInterval(_this.startTimer, 1000);
            let info = JSON.parse(_this.encode_str);
            _this.acceptUser = {
              user_id: info.invite_user_id,
              user_name: info.invite_user_name
            };

            // 合流
            if (parseInt(_this.isMergeStream) && isJoin) {
              _this.mergeStream();
            }
          });
      });
    },

    hangUp() {
      this.leaveRoom();
    },

    async leaveRoom() {
      // 离开房间，清空定时器
      clearInterval(this.interVal);
      clearInterval(this.timeOut);
      this.hangUpBtn = false;
      if (this.msgObj) {
        this.msgObj.close();
        this.msgObj = null;
      }
      try {
        // 关闭合流
        if (
          parseInt(this.acceptUser.user_id) > 0 &&
          parseInt(this.isMergeStream)
        ) {
          await this.myRoom.stopMergeStream();
        }

        // 遍历 tracks，逐个销毁释放
        for (const track of this.localTracks) {
          track.release();
        }
        if (this.users.length > 0) {
          await this.myRoom.leaveRoom();
          let type = this.acceptUser.user_id > 0 ? 2 : 1;
          leaveRoom({ encode_str: this.encode_str, type: type });
        }
        this.$emit('videoCallClose');
        this.$router.push('/Index');
      } catch (err) {
        let msg = err.msg;
      }
    },

    mergeStream() {
      // 合流
      const users = this.myRoom.users;
      let videoTrackId = [];
      let audioTrackId = [];
      for (const user of users) {
        // 每个用户当前的 TrackInfo 列表
        const userTrackInfoList = user.publishedTrackInfo;
        for (const temp of userTrackInfoList) {
          if (temp.kind === 'video') {
            videoTrackId.push(temp.trackId);
          }
          if (temp.kind === 'audio') {
            audioTrackId.push(temp.trackId);
          }
        }
      }
      // 开始合流
      this.myRoom.addMergeStreamTracks([
        { trackId: videoTrackId[0], x: 0, y: 0, w: 640, h: 720 },
        { trackId: videoTrackId[1], x: 640, y: 0, w: 640, h: 720 },
        { trackId: audioTrackId[0] },
        { trackId: audioTrackId[1] }
      ]);
    },

    startTimer() {
      this.seconds += 1;
      if (this.seconds >= 60) {
        this.seconds = 0;
        this.minutes += 1;
      }
      if (this.seconds === 0 && this.minutes === 8) {
        this.$notify({
          title: '提示',
          message: '本视频将于两分钟后结束',
          offset: 100,
          type: 'warning',
          duration: 5000
        });
      }
    }
  }
};
</script>

<style lang="css">
.roomOperation .svg-icon {
  width: 1.6rem;
  height: 1.6rem;
}

.roomOperation .item.callup .svg-icon {
  width: 1.8rem;
  height: 1.8rem;
}
</style>
